export default "__VITE_ASSET__D1Oqt4sZ__"